import React from 'react';
import { Nav } from 'react-bootstrap';
import './navbar.css';
import RRD_logo from "../../assets/logo/rrd.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse,faBook,faPhone,faXmark } from "@fortawesome/free-solid-svg-icons";
import { faBars } from "@fortawesome/free-solid-svg-icons";

export default function RRDNavbar() {
// const handleClickbtn = (val)=>{
//     window.location.href = "/contactus";
// }
  return (
    <div className="nav-header-lap mb-1">
        <div>
            <div className="nav-main-container py-3 px-2">
                <div href="#" className="nav-header-logo">
                  <a className="navbar-brand" href="/">
                      <img
                      className='home-logo-out'
                      src={RRD_logo}      
                      alt="RRD Logo"       
                      />
                  </a>
                </div>              
                <div className="nav-header-content">
                  <Nav className='nav-container'>                        
                      <Nav.Link href="/" className="nav-header-text px-3" >
                        <h5 className='font-red'>Home</h5>
                      </Nav.Link>                      
                      <Nav.Link href="/projects" className="nav-header-text px-3">                      
                        <h5 className='font-red'>Projects</h5>
                      </Nav.Link>
                      <Nav.Link href="/aboutus" className="nav-header-text px-3">                      
                        <h5 className='font-red'>About Us</h5>
                      </Nav.Link>
                      <Nav.Link href="/joint-venture" className="nav-header-text px-3">                       
                       <h5 className='font-red'>Joint Ventures</h5>
                      </Nav.Link>       
                      <Nav.Link href="/emi-calculator" className="nav-header-text px-3">
                        <h5 className='font-red'>EMI Calculator</h5>
                      </Nav.Link>                    
                      <Nav.Link href="/contactus" className="nav-header-text px-3">
                        <h5 className='font-red'>Contact Us</h5>
                      </Nav.Link>                          
                  </Nav>
                  
                  <button
                      className="navbar-toggler toggle-btn"
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasNavbar"
                      aria-controls="offcanvasNavbar"
                  >
                      <FontAwesomeIcon
                        icon={faBars}
                        className="bars-icon"
                        />
                  </button>
                </div> 
                {/* Off-canvas menu */}
                <div
                    className="offcanvas offcanvas-end"
                    tabIndex="-1"
                    id="offcanvasNavbar"
                    aria-labelledby="offcanvasNavbarLabel"
                >
                    <div className="offcanvas-header">
                    <div>
                        <img
                        className='home-logo'
                        src={RRD_logo}      
                        alt="RRD Logo"       
                        />
                    </div>
                    <button
                        type="button"
                        className="btn-close closebtn"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    > <FontAwesomeIcon icon={faXmark} /></button>
                    </div>
                    
                    <div className="offcanvas-body">
                      <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                        <li className="nav-item">
                          <div className='mobileview-nav'><FontAwesomeIcon icon={faHouse} /> <a className={`nav-link`} href="/">Home</a></div>
                        </li>
                        <li className="nav-item">
                          <div className='mobileview-nav'><FontAwesomeIcon icon={faHouse} /> <a className={`nav-link`} href="/">Projects</a></div>
                        </li>
                        <li className="nav-item">
                        <div className='mobileview-nav'><FontAwesomeIcon icon={faBook} /> <a className={`nav-link `}  href="about">About Us</a></div>
                        </li>
                        <li className="nav-item">
                        <div className='mobileview-nav'> <FontAwesomeIcon icon={faBook} /><a className={`nav-link `}  href="blogs">Blogs</a> </div>
                        </li>
                
                        <li className="nav-item">
                        <div className='mobileview-nav'><FontAwesomeIcon icon={faPhone} /> <a className={`nav-link`} href="contact">Contact</a></div>
                        </li>
                      </ul>
                    </div>
                </div>           
            </div> 
        </div>
    </div>
  );
}
